import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-specification-upload',
  templateUrl: './specification-upload.component.html',
  styleUrls: ['./specification-upload.component.scss'],
})
export class SpecificationUploadComponent {
  fileInput: File;
  fileDetails: any;
  @Output() uploadSpec = new EventEmitter();

  constructor(private dialogRef: MatDialogRef<SpecificationUploadComponent>) {}

  onFileUpload(event: Event) {
    this.fileDetails = (event.target as HTMLInputElement).files[0];
  }

  uploadAddress() {
    this.dialogRef.close(this.fileDetails);
  }
}
